module.exports = __webpack_public_path__ + "static/ssb-day4-5c5fd12cf97588e20a0060e71c29823e.png";